import { SystemDescriptions } from "src/common/descriptions";
import { ExpenditureRecord } from "src/common/models/expenditureRecord";
import { formatToCurrency, formatToDisplayDatetime } from "src/common/util";
import { SummaryType } from "src/components/SearchableTable/types";
import { searchableTableUtils } from "src/components/SearchableTable/utils";
import { TableCellElement } from "./TableCellElement";

const descriptions = SystemDescriptions.PAGES.PAYABLE_CONTRACT.INCOME_RECORDS
const commonDescriptions = SystemDescriptions.PAGES.COMMON

export enum ColumnsKeys {
    NO = 'key',
    DATETIME = 'datetime',
    DESCRIPTION = 'description',
    IS_LOAN = 'isLoan',
    TOTAL = 'total',
    ACTIONS = 'ACTIONS',
}

export const TABLE_COLUMNS: any = [
    {
        title: descriptions.TABLE_COLUMNS.ID,
        dataIndex: ColumnsKeys.NO,
        key: ColumnsKeys.NO,
        align: searchableTableUtils.alignment.centerAlign,
        render: (value, record: ExpenditureRecord) => {
            return <TableCellElement
                isDeleted={record.isDeleted}
                value={value}
            />
        },
    },
    {
        title: descriptions.TABLE_COLUMNS.DATETIME,
        dataIndex: ColumnsKeys.DATETIME,
        key: ColumnsKeys.DATETIME,
        align: searchableTableUtils.alignment.centerAlign,
        render: (value, record: ExpenditureRecord) => {
            return <TableCellElement
                isDeleted={record.isDeleted}
                value={formatToDisplayDatetime(value)}
            />
        },
    },
    {
        title: descriptions.TABLE_COLUMNS.DESCRIPTION,
        dataIndex: ColumnsKeys.DESCRIPTION,
        key: ColumnsKeys.DESCRIPTION,
        align: searchableTableUtils.alignment.centerAlign,
        render: (value, record: ExpenditureRecord) => {
            return <TableCellElement
                isDeleted={record.isDeleted}
                value={value}
            />
        },
    },
    {
        title: descriptions.TABLE_COLUMNS.IS_LOAN,
        dataIndex: ColumnsKeys.IS_LOAN,
        key: ColumnsKeys.IS_LOAN,
        align: searchableTableUtils.alignment.centerAlign,
        render: (value, record: ExpenditureRecord) => {
            return <TableCellElement
                isDeleted={record.isDeleted}
                value={value === 1 ? commonDescriptions.YES : commonDescriptions.NO}
            />
        },
    },
    {
        title: descriptions.TABLE_COLUMNS.TOTAL,
        dataIndex: ColumnsKeys.TOTAL,
        key: ColumnsKeys.TOTAL,
        align: searchableTableUtils.alignment.centerAlign,
        render: (value, record: ExpenditureRecord) => {
            return <TableCellElement
                isDeleted={record.isDeleted}
                value={formatToCurrency(value)}
            />
        },
    },
];

export const summaryColumns: Partial<Record<ColumnsKeys, SummaryType>> = {
    [ColumnsKeys.TOTAL]: SummaryType.SUM,
    [ColumnsKeys.NO]: SummaryType.COUNT,
}